module.exports = __webpack_public_path__ + "static/media/loupe.989c4163.svg";